import { Component, OnInit } from '@angular/core'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { SecurityQuestions } from '../../../../api/models/security-questions'
import {
  AppSettingService,
  SecurityQuestionService,
} from '../../../../api/services'
import { SecurityAnswersService } from '../../../../api/services/security-answers.service'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { MfaType } from '../../../../api/models'
import { environment } from '../../../../../environments/environment'
@Component({
  selector: 'app-question-list',
  templateUrl: './question-list.component.html',
  styleUrls: ['./question-list.component.css'],
})
export class QuestionListComponent implements OnInit {
  questions: SecurityQuestions[]
  questionForm: UntypedFormGroup
  questionsArray: UntypedFormArray
  userName = ''
  public displaypopup: boolean = false
    public title: string = 'Security Questions'
    version: string = '';

    public statusErroDisplay_403: boolean = false;
    public statusErroDisplay_404: boolean = false;
  constructor(
    private appSettingsService: AppSettingService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private questionService: SecurityQuestionService,
    private questionAnswerService: SecurityAnswersService,
  ) {
    this.questionForm = this.fb.group({
      questionFormArray: this.fb.array([]),
    })
  }

  getFormAsArray() {
    return this.questionForm.get('questionFormArray') as UntypedFormArray
  }
  ngOnInit() {
      this.displaypopup = true
      this.version = environment.version;
    this.route.queryParams.subscribe((params) => {
      const data = params
      this.userName = data.u_Name
    })

    this.questionService
      .securityQuestionGetSecurityQuestion({
        Username: this.userName,
      })
      .subscribe(
        (Result) => {
          if (Result == null) {
            this.router.navigate(['/'])
            return
          }
          this.questions = Result.data

          this.questionForm = this.fb.group({
            questionFormArray: this.fb.array([]),
          })
          this.questionsArray = this.questionForm.get(
            'questionFormArray',
          ) as UntypedFormArray
          this.questions.forEach((question) => {
            this.questionsArray.push(this.createQuesionGroup(question))
          })

          this.displaypopup = this.questions?.length > 0
        },
        (err) => {
          this.displaypopup = false
          console.error(err)
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            detail: `Couldn't fetch question list`,
            summary: 'Something went wrong',
            life: 7000,
          })
        },
      )
  }
  onSubmitForm(): void {
    const formValue = this.questionForm.getRawValue()
      .questionFormArray as Array<any>
    const filteredFormValue = formValue
      .filter((value) => value.isSelected && value.answer.length > 0)
      .map((val) => ({
        questionId: val.questionId,
        answerDescription: val.answer,
      }))
    this.messageService.clear()
    if (filteredFormValue.length < formValue.length) {
      const summary = 'Answer all questions'
      const detail = 'You need to answer all the questions'
      this.displayErrorMessage(summary, detail)
    } else {
      this.questionAnswerService
        .securityAnswersSetanswerlist$Response({
          Uname: this.userName,
          body: {
            securityAnswers: filteredFormValue,
          },
        })
        .subscribe(
          (val) => {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              detail: `verified Successfully`,
              summary: 'verified Successfully',
              life: 7000,
            })

            let isTwoFactorOn =
              CareFinitySession.applicationSettings.accountPolicy.mfaType !=
              MfaType.None
            if (isTwoFactorOn === true) {
              this.router.navigate(['mfa'], {
                state: {},
                queryParams: { u_Name: this.userName },
              })
            } else {
              if (
                CareFinitySession.applicationSettings.isEmergencyTokenEnabled
              ) {
                this.router.navigate(['Validate-token'], {
                  state: {},
                  queryParams: { u_Name: this.userName },
                })
              } else {
                this.router.navigate(['Forgotpwd-change'], {
                  state: {},
                  queryParams: { u_Name: this.userName },
                })
              }
            }
          },
          (err) => {
              if (err.status == 401 || err.status == 403) {
                  //alert("Security questions and answers don't match!")
                  this.statusErroDisplay_403 = true;
                
              }

             

              if (err.status == 404) {
                //  alert('Specified user does not exist!')

                  this.statusErroDisplay_404 = true;
              }

                 

            console.error(err)
            this.messageService.add({
              key: 'alertToast',
              severity: 'error',
              detail: `Security questions and answers don't match!`,
              summary: 'Error in verifying answers',
              life: 7000,
            })
          },
        )
    }
  }
  private displayErrorMessage(summary: string, detail: string): void {
    this.messageService.add({
      key: 'alertToast',
      severity: 'error',
      detail,
      summary,
      life: 7000,
    })
  }
  private createQuesionGroup(question: SecurityQuestions): UntypedFormGroup {
    return this.fb.group({
      questionDesciption: [question.description],
      questionId: [question.questionId],
      isSelected: [false],
      answer: [''],
    })
  }
}
